import * as React from "react";
import { connect } from "react-redux";

import { RootState, Dispatch } from "../../../store/types";
import { ProductLayout } from "../../../models";
import * as actions from "../actions";
import * as selectors from "../selectors";
import { LayoutChoiceState } from "../reducer";
import Carousel from "./LayoutCarousel";
import CarouselItem from "./LayoutCarouselItem";

export interface LayoutCarouselProps extends LayoutChoiceState {
  chosenLayoutIndex: number;
  fetchLayouts: () => void;
  setChosenLayout: (l: ProductLayout) => void;
}

class LayoutCarousel extends React.Component<LayoutCarouselProps> {
  public componentDidMount() {
    this.props.fetchLayouts();
  }

  // Looks damn weird because react-slick is weird; need to render empty div if nothing, else render
  //  and empty div around the main content
  private renderLayoutCarouselItems = () =>
    this.props.layouts.length ? (
      this.props.layouts.map(layout => (
        <div key={layout.id}>
          <CarouselItem {...layout} />
        </div>
      ))
    ) : (
      <div />
    );

  public render() {
    return (
      <Carousel
        isLoading={this.props.isLayoutsLoading}
        onChange={this.handleLayoutChange}
        initialSlide={this.props.chosenLayoutIndex}
      >
        {this.renderLayoutCarouselItems()}
      </Carousel>
    );
  }

  private handleLayoutChange = (index: number) =>
    this.props.setChosenLayout(this.props.layouts[index]);
}

const mapStateToProps = (state: RootState): Partial<LayoutCarouselProps> => ({
  layouts: selectors.layouts(state),
  chosenLayout: selectors.chosenLayout(state),
  chosenLayoutIndex: selectors.chosenLayoutIndex(state),
  isLayoutsLoading: selectors.isLayoutsLoading(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<LayoutCarouselProps> => ({
  fetchLayouts: () => dispatch(actions.fetchLayouts()),
  setChosenLayout: (l: ProductLayout) => dispatch(actions.setChosenLayout(l)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutCarousel);



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/components/LayoutCarouselContainer.tsx